import { render, staticRenderFns } from "./form_subcategories_marketplace_component.vue?vue&type=template&id=630f32be&scoped=true"
import script from "./form_subcategories_marketplace_component.vue?vue&type=script&lang=js"
export * from "./form_subcategories_marketplace_component.vue?vue&type=script&lang=js"
import style0 from "./form_subcategories_marketplace_component.vue?vue&type=style&index=0&id=630f32be&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630f32be",
  null
  
)

export default component.exports